import { MutableRefObject, useEffect, useState } from "react";

import loggingService from "@app/util/logging";

export const useIsOverflow = (ref: MutableRefObject<any>): [boolean, number] => {
  const [overflowIndex, setOverflowIndex] = useState<number>(-1);

  useEffect(() => {
    try {
      const { current } = ref;
      const observer = new ResizeObserver(() => {
        const hasOverflow =
          current.scrollHeight > 0 &&
          current.offsetHeight > 0 &&
          current.scrollHeight > current.offsetHeight;

        if (hasOverflow) {
          const overflowIndex = Array.from(current.childNodes).findIndex(
            (child) => (child as HTMLElement).offsetTop > current.offsetTop
          );
          setOverflowIndex(overflowIndex);
        } else {
          setOverflowIndex(-1);
        }
      });

      if (current) {
        observer.observe(current);
      }

      return () => {
        observer.disconnect();
      };
    } catch (e) {
      loggingService.error("Error in useIsOverflow", e);
    }
  }, [ref]);

  return [overflowIndex >= 0, overflowIndex];
};
